import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import Header, { HeaderLeft, HeaderRight } from 'layout/Header/Header';
import Button from 'components/bootstrap/Button';
import useDarkMode from 'hooks/useDarkMode';
import CommonHeaderRight from './CommonHeaderRight';
import Avatar from 'components/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'stores/store';
import { selectCompanyId, selectProjectId } from 'stores/projectCompanySlice';
import { capitalizeFirstLetter, getCompany, getRoleName } from 'helpers/helpers';
import AvatarImage from 'assets/img/avatar.jpg';
import { authMenu, settingsMenu } from 'menu';
import { logout } from 'stores/authSlice';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'components/bootstrap/Dropdown';

const DashboardHeader = () => {
	const { darkModeStatus } = useDarkMode();

	const { user } = useSelector((state: RootState) => state.auth);
	const companyId = useSelector((state: RootState) => selectCompanyId(state));
	const projectId = useSelector((state: RootState) => selectProjectId(state));

	const company = () => getCompany(companyId, user);
	const dispatch = useDispatch<AppDispatch>();

	const currentCompany = company();

	const navigate = useNavigate();
	return (
		<Header>
			<HeaderLeft>
				{user && currentCompany && projectId ? (
					<div className='d-flex align-items-center' data-tour='active-organization-tour'>
						<div className='row g-4'>
							<div className='col-md-auto'>
								<div
									className={classNames('fs-4', 'text-uppercase', {
										'text-dark': !darkModeStatus,
									})}>
									{currentCompany.name.toUpperCase()}
								</div>
								<div className='fs-6'>
									{' '}
									{currentCompany.business_registration ?? 'Pending Completion'}
								</div>
							</div>
						</div>
					</div>
				) : (
					<div />
				)}
			</HeaderLeft>
			<HeaderRight>
				<CommonHeaderRight
					afterChildren={
						<div className='col d-flex align-items-center' data-tour='profile-tour'>
							{user && company() && (
								<Dropdown className='d-inline-block'>
									<DropdownToggle hasIcon={false}>
										<div className='col d-flex align-items-center'>
											<div className='me-3'>
												<Avatar
													srcSet={user?.profile_photo ?? AvatarImage}
													src={user?.profile_photo ?? AvatarImage}
													size={48}
													color='primary'
												/>
											</div>
											<div>
												<div className='fw-bold fs-6 mb-0'>
													{capitalizeFirstLetter(user?.name ?? '')}
												</div>
												<div className='text-muted'>
													<small>{getRoleName(companyId, user)}</small>
												</div>
											</div>
										</div>
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd>
										<DropdownItem>
											<Button
												icon={settingsMenu.profile.icon}
												tag='a'
												onClick={() => navigate(settingsMenu.profile.path)}>
												Profile
											</Button>
										</DropdownItem>
										<DropdownItem>
											<Button
												icon='PowerSettingsNew'
												tag='a'
												onClick={() => {
													dispatch(logout());
													navigate(authMenu.login.path, {
														replace: true,
													});
												}}>
												Logout
											</Button>
										</DropdownItem>
									</DropdownMenu>
								</Dropdown>
							)}
						</div>
					}
				/>
			</HeaderRight>
		</Header>
	);
};

export default DashboardHeader;
